import { TicketRefType } from "~/operations";
import SvgIcon from "@mui/material/SvgIcon";
import {
  AttachIcon,
  AzureIcon,
  FlyingEnvelopeIcon,
  GithubIcon,
  GitlabIcon,
  JiraIcon,
  ServiceNowIcon,
  WebhookIcon,
  ZendeskIcon,
} from "~/icons";

export const ticketTypeIconMap: Record<TicketRefType, typeof SvgIcon> = {
  [TicketRefType.Zendesk]: ZendeskIcon,
  [TicketRefType.Jira]: JiraIcon,
  [TicketRefType.Github]: GithubIcon,
  [TicketRefType.Email]: FlyingEnvelopeIcon,
  [TicketRefType.Gitlab]: GitlabIcon,
  [TicketRefType.AzureDevops]: AzureIcon,
  [TicketRefType.ServiceNow]: ServiceNowIcon,
  [TicketRefType.Webhook]: WebhookIcon,
  [TicketRefType.Unknown]: AttachIcon,
};
